import { render, staticRenderFns } from "./downLoadDetail.vue?vue&type=template&id=67cbe6a6&scoped=true&"
import script from "./downLoadDetail.vue?vue&type=script&lang=js&"
export * from "./downLoadDetail.vue?vue&type=script&lang=js&"
import style0 from "./downLoadDetail.vue?vue&type=style&index=0&id=67cbe6a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cbe6a6",
  null
  
)

export default component.exports